import { z } from 'zod';
/** The owner messages an agency can switch off. The memo link itself is never one of them: the owner signs it. */
export const OWNER_EVENT_KEYS = [
    'visit_requested',
    'visit_confirmed',
    'token',
    'memo',
    'registered',
    'closed',
];
export const ownerEventsSchema = z.object({
    events: z.object(Object.fromEntries(OWNER_EVENT_KEYS.map((key) => [key, z.boolean().optional()]))),
});
//# sourceMappingURL=owner-events.js.map